<script lang="ts">
	import type { ComponentProps } from 'svelte';
	import Button from '$lib/components/atoms/button/Button.svelte';

	interface Props {
		text: string;
		showCloseButton?: boolean;
		closeButton?: ComponentProps<typeof Button>;
		onClose?: () => void;
	}

	const {
		text,
		showCloseButton = true,
		onClose = () => {},
		closeButton = {
			variant: 'ghost',
			color: 'white',
			size: 'md',
			icon: 'close',
		},
	}: Props = $props();
</script>

<div
	class="snackbar flex flex-justify-between items-center bg-coloredneutral text-coloredneutral-weakest text-md rd-1 px-4 py-2 m-4 min-h-36 gap-4"
>
	{text}
	{#if showCloseButton}
		<Button {...closeButton} onclick={onClose} />
	{/if}
</div>

<style>
	.snackbar {
		user-select: none;
		width: 500px;
		max-width: calc(100vw - 2rem);
		min-height: 3rem;
		box-shadow:
			0px 1px 18px 0px rgba(0, 0, 0, 0.12),
			0px 6px 10px 0px rgba(0, 0, 0, 0.14),
			0px 3px 5px -1px rgba(0, 0, 0, 0.2);
	}
</style>
